import layout from '@/components/common/layout';
import teacherList from '../views/teacher/list';
import teacherCreate from "../views/teacher/create";

export default [
    {
        path: '/teacher',
        component: layout,
        children: [
            {
                path: 'list',
                meta: {
                    metaInfo: {
                        title: "老师列表",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '380',// 父选项
                        child: 'teacher_list',// 子选项
                    }
                },
                component: teacherList,
            },
            {
                path: 'create',
                meta: {
                    metaInfo: {
                        title: "新增老师",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '380',// 父选项
                        child: 'teacher_list',// 子选项
                    }
                },
                component: teacherCreate,
            },
            {
                path: 'edit',
                meta: {
                    metaInfo: {
                        title: "编辑老师",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '380',// 父选项
                        child: 'teacher_list',// 子选项
                    }
                },
                component: teacherCreate,
            },
        ]
    },
];
